import React from 'react';

export const isCompanyContext = React.createContext();